module.exports = __webpack_public_path__ + "img/rhoc.65cfa0ce.svg";